module.exports = __webpack_public_path__ + "images/0c996fb242dd54b130cd405ffd44c035-no_icon.png";